import React from 'react';
import Navbar from '../components/Navbar';
import HeroEn from '../components/HeroEn';
// This is the English word-by-word translation version of the Home Page.
import AboutSectionEn from '../components/AboutSectionEn';
import FeaturesEn from '../components/FeaturesEn';
import DriverWaitlistEn from '../components/DriverWaitlistEn';
import DriverFAQEn from '../components/DriverFAQEn';
import FooterEn from '../components/FooterEn';
import FooterEnWithLangSwitch from '../components/FooterEn';

const HomePageEn: React.FC = () => {
  return (
    <>
      {/* English version of the Home Page */}
      <HeroEn />
      <AboutSectionEn />
      <FeaturesEn />
      <div id="waitlist">
        <DriverWaitlistEn />
      </div>
      <DriverFAQEn />
      <FooterEnWithLangSwitch />
    </>
  );
};

export default HomePageEn;
